import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "./ckeditor.css";

const CkEditorInput = ({ value = "", onChange = () => {}, height = 400 }) => {
  return (
    <div style={{ minHeight: height }}>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        onReady={(editor) => {
          console.log("CKEditor is ready");
          // Optional: force height if needed using model
          try {
            const editableElement = editor?.ui?.getEditableElement();
            if (editableElement) {
              editableElement.style.minHeight = `${height}px`;
            }
          } catch (e) {
            console.warn("Height styling failed:", e);
          }
        }}
        onChange={(event, editor) => {
          if (!editor) return;
          const data = editor.getData();
          onChange(data);
        }}
        config={{
          placeholder: "Enter description...",
          toolbar: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "|",
            "insertTable",
            "blockQuote",
            "undo",
            "redo",
          ],
          table: {
            contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
          },
        }}
      />
    </div>
  );
};

export default CkEditorInput;
